import { manifest as heroAManifest } from '../HeroA/manifest';

export const manifest = {
  ...heroAManifest,
  code: 'reserve',
  label: 'Template Institucional',
};
